import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Collapse from '@material-ui/core/Collapse';
import Cancel from '@material-ui/icons/Cancel';

const useStyles = makeStyles({
  errorbox: {
    backgroundColor: '#f1d8d4',
    borderColor: '#ba3a26',
    padding: '1rem',
    borderStyle: 'solid',
    display: 'flex',
    borderWidth: '2px',
  },
  errorIcon: {
    color: '#ba3a26',
    marginRight: '1rem',
  },
});

const ErrorTextBox = ({ message, autoHideDuration }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(true);

  useEffect(() => {
    if (autoHideDuration) {
      const timer = setTimeout(() => {
        setOpen(false);
      }, autoHideDuration);
      return () => clearTimeout(timer);
    }
  }, [autoHideDuration]);

  return (
    <Collapse in={open}>
      <Paper elevation={0} className={classes.errorbox}>
        <Cancel className={classes.errorIcon} />
        <Typography display="inline" variant="body1">
          {message}
        </Typography>
      </Paper>
    </Collapse>
  );
};

ErrorTextBox.propTypes = {
  message: PropTypes.node,
  autoHideDuration: PropTypes.number,
};
ErrorTextBox.defaultProps = {
  message: '',
  autoHideDuration: 7000,
};

export default ErrorTextBox;
